export const MAIN_697_SLUG_MAP: Record<string, string> = {
  twink: 'harry-nb5yms',
  boy: 'harry-nb5yms',
  leather: 'jason-e16ulp',
  clean_cut: 'luca-moretti-bnsbbr',
  otter: 'mad-mixel',
  bear: 'magnus-allen',
  geek: 'maxim-d4l9qf',
  trans: 'morgan-baiad1',
  pup: 'pup-uvyckd',
  daddy: 'rafael-ir5bux',
  queer: 'rio-gfifs8',
  jock_sporty: 'thomas-14cy7z',
};
